import React from "react"
import { Button } from "~/ui/button"
import searchIcon from "~/images/icons/search"

type MobileSearchButtonProps = {
  onClick: () => void
}

export const MobileSearchButton: React.FC<MobileSearchButtonProps> = ({ onClick }) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onClick}
      className="h-9 w-9"
      aria-label="Open search"
    >
      <img {...searchIcon} alt="" className="h-5 w-5" />
    </Button>
  )
}
